<template>
  <div class="content">
    <div class="row mt-3">
      <div class="col-12">
        <card class="archives-card" card-body-classes="table-full-width">
          <!--<h4 slot="header" class="card-title"></h4>-->
          <div slot="header" class="row">

            <div class="col-sm-6 col-md-6 col-lg-6">
              <base-input
                v-bind:placeholder="$t('emails.search.placeholder')"
                v-model="search"
                @keyup="onSearchInputChange"
                class="search-input"
              >
              </base-input>
            </div>
            <div  class="col-sm-2 col-md-2 col-lg-2 list-project-type">
              <el-select
                class="select-primary select-inline"
                name="status"
                size="large"
                @change="onChangeStatus"
                v-model="filters.status">
                <el-option
                  v-for="option in [{value: 0, label: $t('select.all')}, {value: 1, label: $t('emails.filter.status.sent')}, {value: 2, label: $t('emails.filter.status.delivered')}, {value: 3, label: $t('emails.filter.status.opened')}, {value: 4, label: $t('emails.filter.status.notReceived')}]"
                  class="select-primary"
                  :value="option.value"
                  :label="option.label"
                  :key="option.label">
                </el-option>
              </el-select>
            </div>
            <div class="col-sm-4 col-md-4 col-lg-4 list-project-date">
              <base-input name="date">
                <el-date-picker
                  type="datetimerange"
                  value-format="timestamp"
                  @change="onChangeDate"
                  range-separator="-"
                  format="yyyy-MM-dd HH:mm"
                  lang="fr"
                  v-bind:start-placeholder="$t('projectForm.labelProjectStart')"
                  v-bind:end-placeholder="$t('projectForm.labelProjectEnd')"
                  v-model="date">
                </el-date-picker>
              </base-input>
            </div>
          </div>
          <EmailsTable :componentName="componentName" :tableData="tableData" :loading="loading" :getEmails="getEmails" :sort_by="sort_by" :handleColumnSorting="handleColumnSorting" :sortingArrowIcon="sortingArrowIcon" />
          <div slot="footer" class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
            <div v-show="tableData.length > 0" class="col-sm-2 list-project-action">
            </div>
            <div v-show="tableData.length > 0"  class="paginate-container">
              <p class="card-category"> {{ $t('archivePage.pageResultsFrom') }} {{ from + 1 }} {{ $t('archivePage.pageResultsTo') }} {{ to }} {{ $t('archivePage.pageResultsOn') }} {{ total }}</p>
              <base-pagination
                v-show="tableData.length > 0"
                class="pagination-no-border"
                v-model="pagination.currentPage"
                :per-page="pagination.perPage"
                :total="total">
              </base-pagination>
            </div>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios';
import { Table, TableColumn, Select, Option, TimeSelect, DatePicker } from 'element-ui';
import { BaseTable } from '@/components';
import { BasePagination, BaseAlert } from 'src/components';
import { Slider, BaseProgress, EmailsTable } from 'src/components/index';

import icons from '../../app/shared/icons';

export default {
  components: {
    BaseTable,
    BasePagination,
    BaseAlert,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [DatePicker.name]: DatePicker,
    [TimeSelect.name]: TimeSelect,
    Slider,
    BaseProgress,
    EmailsTable
  },
  computed: {
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.total;
    }
  },
  created () {
    this.getEmails();
  },
  data() {
    return {
      pagination: {
        perPage: 20,
        currentPage: 1,
        total: 0
      },
      loading:false,
      tableData: [],
      componentName: 'EmailsList',
      total: 0,
        date: null,
      search: "",
      filters: {
        status: 0
      },
      sort_by: {
        column: "time",
        order: '-1'
      },
      sortingArrowIcon: `<svg xmlns="http://www.w3.org/2000/svg" width="9" height="14" viewBox="0 0 9 14">
                <g transform="translate(-8413 592)">
                  <path d="${icons.sortingArrow}" transform="translate(8413 -592)" fill="#bfc3cd"></path>
                  <path d="${icons.sortingArrow}" transform="translate(8422 -578) rotate(180)" fill="#bfc3cd"></path>
                </g>
              </svg>`
    };
  },
  methods: {
    onChangeDate() {
       this.getEmails();
    },
    getEmails() {
      let _this = this;
      this.loading=true;
      let reqFilters = {};
      reqFilters.from = (this.pagination.perPage * (this.pagination.currentPage - 1)) + 1;
      reqFilters.limit = this.pagination.perPage;
        reqFilters.ranges = this.date || [];
      reqFilters.search = this.search;
      reqFilters.status = this.filters.status === 0 ? [] : [this.filters.status];
      reqFilters.sort_by = this.sort_by;
      axios.post('/metric/email-status/readAll', reqFilters).then(response => {
        let data = response.data;
        if (data.success) {
          _this.loading=false;
          _this.tableData = data.data.map((element) => {
            if (element.status === 1) {
              element.statusIconClass = "bg-info p-1 rounded text-center text-white";
              element.statusTitle = this.$i18n.t('emails.filter.status.sent');
            } else if(element.status === 2) {
              element.statusIconClass = "bg-success p-1 rounded text-center";
              element.statusTitle = this.$i18n.t('emails.filter.status.delivered');
            } else if(element.status === 3) {
              element.statusIconClass = "bg-light p-1 rounded text-center text-white";
              element.statusTitle = this.$i18n.t('emails.filter.status.opened');
            } else {
              element.statusIconClass = "bg-danger p-1 rounded text-center text-white";
              element.statusTitle = this.$i18n.t('emails.filter.status.notReceived');
            }
            return element;
          });
          _this.total = data.total;
        } else {
          if (data.need_auth) {
            _this.$router.push({path: '/login'});
          } else {
            _this.$notify({
              message:  this.$i18n.t('serverReply.errorEmailRead'),
              timeout: 10000,
              icon: 'tim-icons icon-bell-55',
              horizontalAlign: 'center',
              verticalAlign: 'top',
              type: 'danger'
            });
          }
        }
      }).catch(() => {
        _this.$notify({
          message: this.$i18n.t('serverReply.errorEmailRead'),
          timeout:   10000,
          icon: 'tim-icons icon-bell-55',
          horizontalAlign: 'center',
          verticalAlign: 'top',
          type: 'danger'
        });
      });
    },
    onSearchInputChange(e) {
      if(e.keyCode === 13 || e.target.value === "") {
        this.getEmails();
      }
    },
    onChangeStatus() {
      // this.filters.status = e.target.value;
      this.getEmails();
    },
    handleColumnSorting(name) {
      const { column, order } = this.sort_by;
      let sortingOrder = '1';
      if (column === name) {
        sortingOrder = order === "1" ? "-1" : "1";
      }
      const { sortingArrow } = icons;
      let groupTransformation, upArrowColor, downArrowColor, upArrowDirection, downArrowDirection;
      switch (this.sort_by.order) {
        case '-1':
          groupTransformation = "translate(-8440 592)", upArrowColor = "#bfc3cd", downArrowColor = "#f400cc", upArrowDirection = "translate(8449 -578) rotate(180)", downArrowDirection = "translate(8440 -592)";
          break;
        case '1':
          groupTransformation = "translate(-8428 592)", upArrowColor = "#f400cc", downArrowColor = "#bfc3cd", upArrowDirection = "translate(8437 -578) rotate(180)", downArrowDirection = "translate(8428 -592)";
          break;
      }
      this.sortingArrowIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="9" height="14" viewBox="0 0 9 14">
                <g transform="${groupTransformation}">
                  <path d="${sortingArrow}" transform="${upArrowDirection}" fill="${upArrowColor}" />
                  <path d="${sortingArrow}" transform="${downArrowDirection}" fill="${downArrowColor}" />
                </g>
              </svg>`;
      this.sort_by = {
        column: name,
        order: sortingOrder
      }
    },
  },
  watch: {
    'pagination.currentPage'() {
      this.getEmails();
    },
    'sort_by'() {
      this.getEmails();
    },
  }
};
</script>
<style>
  .pagination-select,
  .search-input {
    width: 200px;
  }
  table.el-table__header {
    margin-bottom: 0px;
  }
  .bootstrap-tagsinput {
    display: inline-block;
    padding: 4px 6px;
    max-width: 100%;
    line-height: 22px;
    vertical-align: middle;
    cursor: text;
  }
  .bootstrap-tagsinput .tag {
    cursor: pointer;
    margin: 5px 3px 5px 0;
    position: relative;
    padding: 3px 8px;
        padding-left: 8px;
    border-radius: 12px;
    font-weight: 500;
    font-size: .75em;
    text-transform: uppercase;
    display: inline-block;
    line-height: 1.5em;
    padding-left: .8em;
    color: #fff;
  }
  div.card.archives-card div.card-body {
    min-height: 500px;
  }
  div.loading {
    position: absolute;
    margin-left: 50%;
    margin-right: -20px;
    top: 50%;
  }
  div.paginate-container {
    display: inherit;
  }
  div.paginate-container p {
    margin-top: 7px;
  }
  tbody.archive-table-body tr td.btn-container {
    visibility: hidden;
    opacity: 0;
    transition:visibility 0.3s linear,opacity 0.3s linear;
  }
  tbody.archive-table-body tr:hover td.btn-container {
    position: relative;
    visibility: visible;
    opacity: 1;
  }
  tbody.archive-table-body tr td.btn-container div {
    width: 200px;
    position: absolute;
    right: 0px;
    bottom: 0px;
  }
  div.card.archives-card div.card-body .progress-container .progress .progress-bar .progress-value {
    /*top: -18px !important;*/
  }
  div.card.archives-card tbody.archive-table-body div.progress-container.progress-primary  {
    margin-top: 0px !important;
  }
  div.card.archives-card tbody.archive-table-body tr td p{
    margin-bottom: 2px;
  }
  div.card.archives-card tbody.archive-table-body tr td p.title {
    padding-top: 0px !important;
  }
  div.card.archives-card .pad-left-20 {
    padding-left: 20px
  }
  .pell-button {
    width: 35px !important;
  }
  td.published-content {
    text-align: center;
  }
  td.published-content i {
    color: rgb(204, 102, 51);
  }
  td.published-content i.success {
    color: #00f2c3;
  }
</style>
